<template>
  <div class="overview_box">
    <div class="show_box">
      <div class="show_item" v-for="(item,index) in showData" :key="index">
        <div class="label">{{ item.label }}</div>
        <div :style="{color:index==2?'#FF8A00':'#666666'}">{{ item.value }}</div>
      </div>
    </div>
    <div class="need_name">需求名称</div>
    <div class="text_box">视频/图文矩阵剪辑需求</div>
    <div class="need_name">任务要求</div>
    <div class="text_box" v-html="task"></div>
    <div class="file_box">
      <div class="item_box">
        <img src="../../assets/img/company/detial/img12.png" alt="">
        <div class="file_info">
          <div class="name">姿身堂红腰子系列系列精华乳液姿身堂红华乳.pdf</div>
          <div class="footer">
            <span style="color: #999999;">1.25MB</span>
            <div>
              <el-link type="primary" style="margin-right: 10px;">预览</el-link>
              <el-link type="primary" >下载</el-link>
            </div>
          </div>
        </div>

      </div>
      <div class="item_box">
        <img src="../../assets/img/company/detial/img12.png" alt="">
        <div class="file_info">
          <div class="name">姿身堂红腰子华乳.zip</div>
          <div class="footer">
            <span style="color: #999999;"> 1.25MB</span>
            <div>
              <el-link type="primary" style="margin-right: 10px;">预览</el-link>
              <el-link type="primary" >下载</el-link>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      showData: [
        {
          label: "需求类型",
          value: "二级分类名称",
        },
        {
          label: "解决方式",
          value: "招募",
        },
        {
          label: "需求预算",
          value: "1000金币",
        },
      ],
      task: `【需求背景/项目介绍】</br> 乐高工作室，计划将乐高套装进行分拣储存备用，以兼职形式招募人力完成分拣工作。</br> 项目Q4预算审计已通过： <a href="https://nd99u.site.101.com/bcs/#/flow/detail?_share=true&bcsAppId=b927b63283344812be679f391273aac6&checklistId=&dataI">https://nd99u.site.101.com/bcs/#/flow/detail?_share=true&bcsAppId=b927b63283344812be679f391273aac6&checklistId=&dataI</a></br>【具体要求】</br> 1、分拣地点：长乐园区企业号五楼乐高工作室。</br> 2、分拣说明：</br> （1）领取100千克的乐高套装零件；</br> （2）使用项目组提供的分拣工具;</br> （3）按照颜色、颗粒类型完成分装。</br> 注：</br> （1）接单前，请同学仔细阅读附件《乐高分拣工作细则V1.3》的内容 </br>（2）如有任何疑问，请咨询项目组：福乐双宝工作室接单号(10016858) </br>【服务成果交付方式】 </br>所领取的100千克乐高套装零件，按照颜色、颗粒类型分装至自封袋，整齐收纳于纸箱中。 </br>【验收标准】 </br>（1）7日内完成100千克乐高零件的分拣工作； </br>（2）零件分类无误，通过工作室对重量与品类的验收。</br> 【服务成果交付方式、格式】 </br>所领取的100千克乐高套装零件，按照颜色、颗粒类型分装至自封袋，整齐收纳于纸箱中。</br> 【验收标准】</br> （1）7日内完成100千克乐高零件的分拣工作；</br> （2）零件分类无误，通过工作室对重量与品类的验收。`,
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.overview_box {
  padding: 36px;
  box-sizing: border-box;
  width: 100%;
   background: #ffffff;
  .show_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 100px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    border: 1px solid #e4e7f0;
    padding: 22px 32px;
    box-sizing: border-box;
    margin-bottom: 32px;
    .show_item {
      font-weight: 500;
      font-size: 14px;
      color: #666666;
      .label {
        margin-bottom: 16px;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
      }
    }
  }
  .need_name {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    margin-bottom: 12px;
  }
  .text_box {
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 22px;
    margin-bottom: 32px;
  }
  .file_box {
    display: flex;
    align-items: center;
    .item_box {
      width: 348px;
      height: 72px;
      background: #f6f6f6;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      align-items: center;
      padding: 0 15px;
      margin-right: 16px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #f6f6f6;
        margin-right: 10px;
      }
      .file_info {
        flex: 1;
        width: 0;

        .name {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-bottom: 6px;
        }
        .footer {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>